import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
import { Message } from "element-ui";
import { getToken } from "@/utils/auth"; // 验权
import { setCookie } from "./utils/support";
const whiteList = ["/login"]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken()) {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store
          .dispatch("GetInfo")
          .then((res) => {
            const data = res.data;
            if (data.cityId !== undefined) setCookie("cityId", data.cityId, 7);
            if (data.cityName !== undefined) setCookie("cityName", data.cityName, 7);
            if (data.type !== undefined) setCookie("userType", data.type, 7);
            if (data.name !== undefined) setCookie("name", data.name, 7);
            if (data.id !== undefined) setCookie("id", data.id, 7);
            if (data.roles !== undefined) setCookie("roles", data.roles, 7);
            if (data.countyName !== undefined) setCookie("countyName", data.countyName, 7);
            // 拉取用户信息
            let menus = res.data1;
            let username = res.data.username;
            store.dispatch("GenerateRoutes", { menus, username }).then(() => {
              // 生成可访问的路由表
              router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
              next({ ...to, replace: true });
            });
          })
          .catch((err) => {
            store.dispatch("FedLogOut").then(() => {
              Message.error(err || "Verification failed, please login again");
              next({ path: "/" });
            });
          });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});



// WEBPACK FOOTER //
// ./src/permission.js